// Variables de ambiente. 
// Este archivo debe estar IGNORADO en el repositorio.
// NO USAR LAS VARIABLES DECLARADAS AQUÍ DIRECTAMENTE. Se deben declarar formalmente en config.js
// y luego usarlas desde allí. Véase config.js para saber como recuperar los valores declarados aquí.

export const URL_API_BOLETAS = 'https://hiu31uck50.execute-api.us-east-1.amazonaws.com/qa';
export const URL_API_HORA = 'https://p2r2e1a7yh.execute-api.us-east-1.amazonaws.com/dev/hora';

export const IdentityPoolId = 'us-east-1:337509f2-9c3b-4708-89a4-a1428535bce7';
// export const IdentityPoolId = 'us-west-2:ea45cff2-ba0c-42db-9c63-51facc1213a0';

export const _PROVIDER = 'sii.login';

export const awsRegion = 'us-east-1';
// export const awsRegion = 'us-west-2';


////////////////////////////
//// TODO por remover
export const USUARIOS_NOTIFICADORES = ['45000052-3'];
//////////////////////////////

export const DESCARGAR_CAF_URL = '/descargar-caf-dev';
// export const DESCARGAR_CAF_LAMBDA = 'cafAutomatico-prod';


export const API_CHECK_VERSION = 'https://370lj6fntj.execute-api.us-east-1.amazonaws.com/prod/version/:PLAT/verificar';

export const CLAVE_TRIBUTARIA_AMBIENTE = 'clave.w.sii.cl'
export const CLAVE_TRIBUTARIA_CALLBACK_URL = 'https://dx8r8aidfc410.cloudfront.net/emitir/'

export const CLAVE_TRIBUTARIA_CLIENT_ID = '4016882c-e614-4a4d-b859-1fca41077847'
export const CLAVE_TRIBUTARIA_SCOPE = 'user_info'
export const CLAVE_TRIBUTARIA_STATE = '730b12d3-0586-42cb-8d8e-57c15125a8a9'

export const CLAVE_UNICA_AMBIENTE = ''
export const CLAVE_UNICA_CLIENT_ID = ''
export const CLAVE_UNICA_SCOPE = ''
export const CLAVE_UNICA_CALLBACK_URL = ''

export const PLATAFORMA = 'WEB'

export const API_ENVIAR_EMAIL = 'https://sg7xg7pc48.execute-api.us-east-1.amazonaws.com/prod/enviar-email'

export const LAMBDA_CONFIG_EMISION = 'eboleta-configuracionesEmision-qa'